"use client"

import { useState } from "react"

export default function SupplierProfile() {
  const [activeTab, setActiveTab] = useState("Face Care")

  const tabs = ["Face Care", "Face Serums", "Sheet Masks", "Custom"]

  const products = [
    { id: 1, image: "/assets/images/skincare-cream-jar.png" },
    { id: 2, image: "/assets/images/serum-bottle.jpg" },
    { id: 3, image: "/assets/images/pink-skincare-product.jpg" },
    { id: 4, image: "/assets/images/face-cream-container.jpg" },
    { id: 5, image: "/assets/images/skincare-jar-with-rings.jpg" },
    { id: 6, image: "/assets/images/natural-skincare-products.png" },
    { id: 7, image: "/assets/images/amber-skincare-bottles.jpg" },
  ]

  const reviews = [
    { id: 1, name: "John Doe", country: "USA", rating: 5 },
    { id: 2, name: "John Doe", country: "Canada", rating: 5 },
    { id: 3, name: "John Doe", country: "Mexico", rating: 5 },
    { id: 4, name: "John Doe", country: "Canada", rating: 5 },
    { id: 5, name: "John Doe", country: "USA", rating: 5 },
  ]

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container-x mx-auto px-4 py-6">
        {/* Back Button */}
        <button
          onClick={() => window.history.back()}
          className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors mb-6"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
          Back to Search Results
        </button>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 mb-8">
          <div className="lg:col-span-4">
            <div className="bg-white rounded-lg shadow-md p-6">
              <div className="text-center mb-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Profile Information</h3>
                <div className="w-32 h-32 mx-auto mb-4 rounded-full bg-gray-200 flex items-center justify-center overflow-hidden p-2">
                  <img
                    src="/assets/images/lumo-skincare-logo.jpg"
                    alt="Lumo Skincare"
                    className="w-full h-full object-contain"
                    onError={(e) => {
                      e.target.style.display = "none"
                      e.target.parentElement.innerHTML = '<span class="text-2xl font-bold text-gray-400">LS</span>'
                    }}
                  />
                </div>
                <div className="relative inline-block">
                  <h2 className="text-xl font-bold text-gray-900">Lumo Skincare</h2>
                  <div className="absolute -right-6 top-1">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="#3B82F6">
                      <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                </div>
                <div className="flex items-center justify-center gap-1 mt-2">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <svg key={star} width="16" height="16" viewBox="0 0 24 24" fill="#FCD34D">
                      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                    </svg>
                  ))}
                </div>
                <p className="text-sm text-gray-600 mt-2">Member since 2021</p>
              </div>

              {/* Contact Information */}
              <div className="mb-6">
                <h3 className="text-base font-semibold text-gray-900 mb-3">Contact Information</h3>
                <div className="space-y-2">
                  <div className="flex items-center gap-2">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                    <span className="text-sm text-gray-600">dm@gmail.com</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                    <span className="text-sm text-gray-600">+03 456 7890</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                    <span className="text-sm text-gray-600">United States</span>
                  </div>
                </div>
              </div>

              {/* Reviews */}
              <div>
                <div className="flex items-center justify-between mb-3">
                  <h3 className="text-base font-semibold text-gray-900">Reviews</h3>
                  <a href="#" className="text-sm text-blue-600 hover:text-blue-700">
                    View All
                  </a>
                </div>
                <div className="space-y-3">
                  {reviews.map((review) => (
                    <div key={review.id} className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-full bg-gray-300 flex-shrink-0"></div>
                      <div className="flex-1">
                        <p className="text-sm font-medium text-gray-900">{review.name}</p>
                        <p className="text-xs text-gray-600">{review.country}</p>
                      </div>
                      <div className="flex items-center gap-0.5">
                        {[1, 2, 3, 4, 5].map((star) => (
                          <svg key={star} width="12" height="12" viewBox="0 0 24 24" fill="#FCD34D">
                            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                          </svg>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-8">
            {/* About Section */}
            <div className="bg-white rounded-lg shadow-md p-6 mb-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">About</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                Lorem Ipsum. Dimentum, V.lac defendo et me omnibus est is capto quaedam in quos. Mi quo nemo, harum, sed
                D nec incendis est dictum detrimento. S octavus peto, nonummy rutundus, qui anteckla platea.
                substantiarum, dictum. Facilisis. unllam congue? Sit eu proventus accumsan non V.mor magnis a uno, pero
                modo in proin monuisse effusund ius V.Duce marcellus capiat tale caedes I pede ac in confessione.
              </p>
            </div>

            {/* Certifications */}
            <div className="bg-white rounded-lg shadow-md p-6 mb-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Certifications</h3>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {[1, 2, 3, 4].map((cert) => (
                  <div key={cert} className="flex flex-col items-center">
                    <div className="w-20 h-20 mb-2">
                      <svg viewBox="0 0 100 100" className="w-full h-full">
                        {/* Badge circle */}
                        <circle cx="50" cy="40" r="20" fill="#000000" />
                        {/* Inner circle detail */}
                        <circle cx="50" cy="40" r="15" fill="#000000" stroke="#FFFFFF" strokeWidth="1.5" />
                        {/* Ribbon left side */}
                        <path d="M40 55 L35 75 L42 70 L45 75 L45 55 Z" fill="#000000" />
                        {/* Ribbon right side */}
                        <path d="M55 55 L55 75 L58 70 L65 75 L60 55 Z" fill="#000000" />
                        {/* Center seal/star */}
                        <circle cx="50" cy="40" r="8" fill="#FFFFFF" />
                        <path
                          d="M50 34 L51.5 38 L55.5 38 L52.5 40.5 L53.5 44.5 L50 42 L46.5 44.5 L47.5 40.5 L44.5 38 L48.5 38 Z"
                          fill="#000000"
                        />
                      </svg>
                    </div>
                    <p className="text-xs font-medium text-gray-900">ISO 9001</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Proficiencies */}
            <div className="bg-white rounded-lg shadow-md p-6 mb-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Proficiencies</h3>

              {/* Tabs */}
              <div className="flex gap-2 mb-6 border-b border-gray-200">
                {tabs.map((tab) => (
                  <button
                    key={tab}
                    onClick={() => setActiveTab(tab)}
                    className={`px-4 py-2 text-sm font-medium transition-colors ${
                      activeTab === tab
                        ? "text-blue-600 border-b-2 border-blue-600"
                        : "text-gray-600 hover:text-blue-600"
                    }`}
                  >
                    {tab}
                  </button>
                ))}
              </div>

              {/* Metrics */}
              <div className="grid grid-cols-2 gap-6 mb-6">
                <div className="flex items-center gap-4">
                  <div className="relative w-20 h-20">
                    <svg className="w-full h-full transform -rotate-90">
                      <circle cx="40" cy="40" r="36" stroke="#E5E7EB" strokeWidth="8" fill="none" />
                      <circle
                        cx="40"
                        cy="40"
                        r="36"
                        stroke="#10B981"
                        strokeWidth="8"
                        fill="none"
                        strokeDasharray="226"
                        strokeDashoffset="0"
                      />
                    </svg>
                    <div className="absolute inset-0 flex items-center justify-center">
                      <span className="text-lg font-bold text-gray-900">100%</span>
                    </div>
                  </div>
                  <p className="text-sm font-medium text-gray-900">Projects Completion</p>
                </div>
                <div className="flex items-center gap-4">
                  <div className="relative w-20 h-20">
                    <svg className="w-full h-full transform -rotate-90">
                      <circle cx="40" cy="40" r="36" stroke="#E5E7EB" strokeWidth="8" fill="none" />
                      <circle
                        cx="40"
                        cy="40"
                        r="36"
                        stroke="#10B981"
                        strokeWidth="8"
                        fill="none"
                        strokeDasharray="226"
                        strokeDashoffset="0"
                      />
                    </svg>
                    <div className="absolute inset-0 flex items-center justify-center">
                      <span className="text-lg font-bold text-gray-900">100%</span>
                    </div>
                  </div>
                  <p className="text-sm font-medium text-gray-900">Response Rate</p>
                </div>
              </div>
            </div>

            {/* Products */}
            <div className="bg-white rounded-lg shadow-md p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Products</h3>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                {products.map((product) => (
                  <div key={product.id} className="aspect-square rounded-lg overflow-hidden bg-gray-100">
                    <img
                      src={product.image || "/placeholder.svg"}
                      alt={`Product ${product.id}`}
                      className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <button className="fixed bottom-8 right-8 px-6 py-3 bg-red-600 text-white rounded-md shadow-lg hover:bg-red-700 transition-colors font-medium z-50">
        Request Quote
      </button>
    </div>
  )
}
